import { TextField, useTheme, InputAdornment, IconButton } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import React from "react";

function SearchInput({
  onChange,
  placeholder = "Search",
  fullWidth,
  value,
  onKeyDown = () => {},
}) {
  const theme = useTheme();
  return (
    <TextField
      autoComplete="off"
      value={value}
      onKeyDown={onKeyDown}
      fullWidth={fullWidth}
      onChange={onChange}
      placeholder={placeholder}
      slotProps={{
        input: {
          "aria-label": placeholder,
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon sx={{ color: theme.palette.action.active }} />
            </InputAdornment>
          ),
          endAdornment: value ? (
            <InputAdornment position="end">
              <IconButton
                aria-label="clear search"
                onClick={() => onChange({ target: { value: "" } })}
                sx={{
                  p: "0.625rem",
                  color: theme.palette.action.active,
                }}
              >
                <CloseIcon />
              </IconButton>
            </InputAdornment>
          ) : null,
        },
      }}
    />
  );
}

export default SearchInput;
